import React from 'react';
const MultiToggle = _ref => {
  let {
    setFilterChoiceState,
    items,
    filters,
    filterName,
    label
  } = _ref;
  const itemToggle = e => {
    setFilterChoiceState(e.currentTarget.checked, e.currentTarget.value, filterName, true);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "col-md-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__field"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter-toggle-multi-select"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "g-radios g-radios--mob-scroll"
  }, Object.keys(items).map((facetLabel, index) => /*#__PURE__*/React.createElement("div", {
    className: "g-radios__item",
    key: `${facetLabel}-radio-index`
  }, /*#__PURE__*/React.createElement("input", {
    tabIndex: 0,
    type: "radio",
    onChange: itemToggle,
    id: `${filterName}-${index}`,
    name: `${filterName}-${index}`,
    checked: filters.includes(facetLabel),
    value: facetLabel,
    title: facetLabel
  }), /*#__PURE__*/React.createElement("label", {
    className: "body-small g-radios__label",
    htmlFor: `${filterName}-${index}`
  }, facetLabel)))))));
};
export default MultiToggle;